export default __webpack_public_path__ + "static/media/fff3.5e867ab7.png";